export function getFormStateStore(_ref, using, extraInfo) {
  let {
    formStateStoreId,
    formStateStoreMap
  } = _ref;
  if (!formStateStoreId) {
    throw new Error(`Using "${using}" outside of form renderer${extraInfo !== null && extraInfo !== void 0 ? extraInfo : ""}`);
  }
  const store = formStateStoreMap.get(formStateStoreId);
  if (!store) {
    throw new Error(`Form state store is not found when using "${using}"${extraInfo !== null && extraInfo !== void 0 ? extraInfo : ""}.\nThis is a bug of Brick Next, please report it.`);
  }
  return store;
}
//# sourceMappingURL=utils.js.map